export default function compose(...fns) {
  return function(v) {
    return fns.reduce((acc, fn) => {
      return fn(acc);
    }, v);
  };
}



// WEBPACK FOOTER //
// ./src/utils/compose.js